import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=074fe7f0&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=ts"
export * from "./InfoCard.vue?vue&type=script&lang=ts"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=074fe7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074fe7f0",
  null
  
)

export default component.exports